import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { loginUrl } from "../../Service/service";
import { postData } from "../../Service/ApiMethod";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css"
// import { auth, provider } from '../../common/firebase';
// import { FacebookAuthProvider, signInWithPopup } from 'firebase/auth';
import Geocode from "react-geocode";
import { useTranslation } from "react-i18next";
// import { candata } from "../../App";
import Loader from "./Loader";
import { useRef } from "react";
import { allTimeZone } from "./Countrycode";
import { lang } from "../../lang";

const Login = (props) => {
  const [ln, setLn] = useState('en')
  const [phone, setPhone] = useState();
  const [password, setPassword] = useState();
  const [error, setError] = useState();
  const [showPassword, setShowPassword] = useState(false)
  const [value, setValue] = useState()
  const [latitude, setLatitude] = useState();
  const [longitude, setLongitude] = useState();
  const [countryCodes, setCountryCode] = useState('')
  const [checkNumber,setChecknumber] = useState("")
  //   const navigateToSuccess = () => {
  //     navigate("/home");
  // };

  // const { newData, setNewData } = useContext(candata)

  const { t } = useTranslation();


  Geocode.setApiKey("AIzaSyAn7_5pFRSJ_i1lbbiitBzZinnYY7VTGxk");







  const countryCode = useRef(null)
  const [countryCod, setCountrycod] = useState('fi')
  useEffect(() => {
    const tokens = localStorage.getItem("catzapp_token");
    const url = window.location.href;
    if (url) {
      const idMatch = url.match(/[\?&]id=(\d+)/);
      const id = idMatch ? idMatch[1] : null;

      console.log("id:", id);
      if (id != null) {
        if (tokens == null) {
          localStorage.setItem("seekershareid", id)
        } else {
          localStorage.setItem("seekershareid", id)
          setTimeout(() => {
            navigate('/home')
          }, 1500)
        }

      }
    }



    // console.log(localStorage.getItem("language"),"checkkkkkk2222222",ln)
    if (localStorage.getItem("language") != null) {
      // localStorage.removeItem("catzapp_token")
      setLn(localStorage.getItem("language"))
    }
    // if(localStorage.getItem("language") != null){
    // setLn(localStorage.getItem("language"))

    locations()
  })

  const locations = async () => {

    if (navigator?.geolocation) {
      await navigator?.geolocation?.getCurrentPosition(function (position) {
        console.log("Latitude is :", position?.coords?.latitude);
        console.log("Longitude is :", position?.coords?.longitude);

        setLatitude(position?.coords?.latitude);
        setLongitude(position?.coords?.longitude);
        localStorage.setItem('lat', position?.coords?.latitude);
        localStorage.setItem('lng', position?.coords?.longitude);
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;
        const reverseGeocodingUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=AIzaSyAn7_5pFRSJ_i1lbbiitBzZinnYY7VTGxk`;

        // call Reverse Geocoding API - https://www.geoapify.com/reverse-geocoding-api/
        fetch(reverseGeocodingUrl)
          .then((response) => response.json())
          .then((data) => {
            if (data.status === 'OK') {
              var address = data.results[0].address_components;
              const countryComponent = data.results[0].address_components.find(
                component => component.types.includes('country')
              );

              if (countryComponent) {
                const countryShortCode = countryComponent.short_name;
                console.log(countryShortCode, "ssssss"); // Display the country short code
                allTimeZone.map((item) => {
                  if (item.Code == countryShortCode) {
                    console.log(item.Code.toLowerCase(), "onnnnnnnn000000", countryCode.current);
                    countryCode.current = item.Code.toLowerCase()
                    setCountrycod(item.Code.toLowerCase())
                  }
                })
              }

              // Do something with the address
              console.log(address, "0000000000000000000000000000000000000000000000");
            } else {
              // Handle the error case
              // console.log('Error: ' + data.status);
            }
          })
          .catch((error) => {
            // console.log('Error: ' + error.message);
          });

      }, function (error) {
        console.log(error);
      });

    } else {
      console.log('error in locating')
    }

  }


  const currentLocation = async (subs) => {

    if (navigator?.geolocation) {
      await navigator?.geolocation?.getCurrentPosition(function (position) {
        console.log("Latitude is :", position?.coords?.latitude);
        console.log("Longitude is :", position?.coords?.longitude);

        setLatitude(position?.coords?.latitude);
        setLongitude(position?.coords?.longitude);
        localStorage.setItem('lat', position?.coords?.latitude);
        localStorage.setItem('lng', position?.coords?.longitude);
        let valu = false
        if (subs != true) {
          var request = {
            radius: 200,
            "latitude": position?.coords?.latitude,
            "longitude": position?.coords?.longitude
          };
          console.log(request, "dxxxxxxxxx");
          fetch("https://api.catzapp.com/recruiter/seekers_list_by_category/", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("catzapp_token"),
            },
            body: JSON.stringify(request),
          })
            .then((response) => response.json())
            .then((res) => {
              console.log('res~~~~~~2222', res.data);

              setTimeout(() => {
                navigate('/map', { state: { userMap: res, isSub: false } })
              }, 1500)


              // let total = 0
              // res.data.map((it) => {
              //   total = it.rec_cnt + total
              // })

              console.log(res.data, "let check valu")
              // reCom.current = total
            })
            .catch(error => { });
        } else {
          fetch("https://api.catzapp.com/recruiter/RecommendedCandidate_Map/", {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("catzapp_token"),
            },
            // body: JSON.stringify(request),
          })
            .then((response) => response.json())
            .then((res) => {
              console.log('res~~~~~~2222', res);

              setTimeout(() => {
                navigate('/map', { state: { userMap: res, isSub: false } })
              }, 1500)


              // let total = 0
              // res.data.map((it) => {
              //   total = it.rec_cnt + total
              // })
              // setListview(res.data)
              // console.log(res.data, "let check valu")
              // reCom.current = total
            })
            .catch(error => { });
        }
        // setTimeout(() => {
        //   navigate('/map')
        // }, 1500)

      }, function (error) {
        console.log(error);
      });

    } else {
      console.log('error in locating')
    }

  };
  const navigate = useNavigate();
  const navigateToLogin = (e, sub) => {
    let subus = sub
    currentLocation(subus)
    // if (navigator.geolocation) {
    //   navigator.permissions.query({name:'geolocation'}).then(permissionStatus => {
    //     if (permissionStatus.state === 'denied') {
    //       alert('Please allow location access.');
    //       window.location.href = "app-settings:location";
    //     } else {
    //      console.log("sssss");
    //     //  window.location.reload();
    //     setTimeout(() => {
    //       navigate('/map')
    //     }, 1000)
    //     }
    //   });
    // } else {
    //   alert('Geolocation is not supported in your browser.');
    // }







    // setTimeout(() => {
    //   alert(e)
    // }, 1500)



  };

  let objItem = {
    phone: checkNumber.charAt(0) === '0' ? "+"+countryCodes+ checkNumber.slice(1) :"+"+countryCodes+ checkNumber,
    password: password,
    user_types: "recruiter",
    // firebase_token: null,
  };

  console.log("static", objItem);

  const [loaderStart, setLoaderstart] = useState(false)
  const handleLogin = async () => {
    console.log(objItem, "okcss")
    setLoaderstart(true)
    if (!phone) {
      alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.SignUp["Enter Your Phone Number"] : "")
      setLoaderstart(false)
    } else if (!password) {
      alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.LoginPassword["Enter Your Password"] : "")
      setLoaderstart(false)
    } else {
      // navigate('/map')


      await postData(objItem, loginUrl)
        .then((res) => res.json())
        .then((data) => {
          setLoaderstart(false)

          try {
            console.log("From Api", data);
            const token = data?.data?.access;
            console.log('token', token)

            localStorage.setItem(
              "catzapp_token",
              token,
              "refresh token",
              data?.data?.refresh,
              "login_Phone",
              data?.data?.user?.phone
            );
            if (token !== undefined) {
              navigateToLogin(data?.message, data?.data?.user?.is_subscribed);
              // setNewData(!newData)
              // alert( data?.message)
            } else {
              alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth[data?.error_message] : "");
            }
          } catch (err) {
            console.log("error hgappended", err);
            setError(err.message, "email already exists");
            alert("Error", error);
          }
        });
    }
  }



  // const handleGoogle = () => {
  //   signInWithPopup(auth, provider).then((data) => {

  //     const email = data?.user?.email
  //     const uid = data?.user?.uid
  //     console.log("data", data)

  //     console.log("email", email)
  //     // localStorage.setItem(
  //     //   "catzapp_token",
  //     //   token,
  //     //   "refresh token",
  //     //   data?.data?._tokenResponse?.refreshToken       ,
  //     //   "login_Email",
  //     //   data?.data?._tokenRespons?.email
  //     // );

  //     let objItems = {
  //       email: email || uid,
  //       user_types: "recruiter",
  //       firebase_token: null,
  //     };

  //     postData(objItems, Social_login)
  //       .then((res) => res.json())
  //       .then((data) => {
  //         console.log("respdatagoogle", data)
  //         const token = data?.data?.access;
  //         console.log('token', token)
  //         localStorage.setItem(
  //           "catzapp_token",
  //           token,
  //           "refresh token",
  //           data?.data?.refresh,
  //           "login_email",
  //           data?.data?.user?.email
  //         );
  //         if (token !== undefined) {
  //           navigateToLogin();
  //           alert(data?.message)
  //         } else {

  //         }

  //       }).catch((err) => {
  //         // console.log("error happended", err);
  //         setError(err.message, "email already exists");
  //         // alert("Error", error);
  //       })
  //     // setValue(data.user.email)
  //     // localStorage.setItem('email', data.user.email)
  //     // localStorage.setItem(
  //     //   "catzapp_token",
  //     // 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoxNjg3MTc2MzUzLCJpYXQiOjE2Nzk0MDAzNTMsImp0aSI6IjZhNDczYjFhNjI0MjQ4MjRhN2JlNjhkY2YxNjgxYTg2IiwidXNlcl9pZCI6ODV9.Y32qQJ1GxcTsvnITMS7lkiDfkpDGEtypGfDZnfIQGtI')
  //     // navigate('/home')

  //   })
  // }

  // const handleFBLogin = (e)=>{
  //   signInWithPopup(auth, fbProvider).then((data)=>{
  //     // setValue(data.user.email)
  //     // localStorage.setItem('email', data.user.email)
  //     navigate('/home')
  //   })
  // }



  // const handleFBLogin = () => {

  //   const provider = new FacebookAuthProvider();
  //   // provider.addScope('user_birthday');
  //   // provider.setCustomParameters({
  //   //   'display':"popup"
  //   // })
  //   signInWithPopup(auth, provider).then((data) => {

  //     const email = data?.user?.email;
  //     console.log("data", data)

  //     console.log("email", email)
  //     // localStorage.setItem(
  //     //   "catzapp_token",
  //     //   token,
  //     //   "refresh token",
  //     //   data?.data?._tokenResponse?.refreshToken       ,
  //     //   "login_Email",
  //     //   data?.data?._tokenRespons?.email
  //     // );

  //     let objItems = {
  //       email: email,
  //       user_types: "recruiter",

  //       firebase_token: null,
  //     };

  //     postData(objItems, Social_login)
  //       .then((res) => res.json())
  //       .then((data) => {
  //         console.log("respdatafb", data)
  //         const token = data?.data?.access;
  //         console.log('token', token)
  //         localStorage.setItem(
  //           "catzapp_token",
  //           token,
  //           "refresh token",
  //           data?.data?.refresh,
  //           "login_email",
  //           data?.data?.user?.email
  //         );
  //         if (token !== undefined) {
  //           navigateToLogin();
  //           alert(data?.data?.message)

  //         } else {
  //           // alert('Error')
  //         }

  //       }).catch((err) => {
  //         console.log("error happended", err);
  //         setError(err.message, "email already exists");
  //         // alert("Error", error);
  //       })
  //     // setValue(data.user.email)

  //     console.log("result", data)


  //     //     const user = result.user;
  //     // console.log("user", user)
  //     //     debugger
  //     //   const credential = FacebookAuthProvider.credential(result);
  //     //  const accessToken = credential.accessToken;

  //     // })
  //     //   .catch((error) => {
  //     //     const errorMessage = error.message;

  //     //     const email = error.customData.email;
  //     //     const credential = FacebookAuthProvider.credentialFromError(error);
  //     //     console.log("error with login")
  //   })
  //   // setValue(data.user.email)   
  //   // localStorage.setItem('email', data.user.email  
  // }





  // useEffect(()=>{
  //   setValue(localStorage.getItem('email'))
  // })

  // const handleLogin = async () => {
  //   try {
  //     let result = await fetch(loginUrl, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         "Accept": "*/*",
  //       },
  //       body: JSON.stringify({ phone, password })

  //     });
  //     result = await result.json();
  //     localStorage.setItem("user-info", JSON.stringify(result));
  //     navigate("/home")
  //     console.log("Result :==", result);

  //   }
  //   catch (err) {
  //     console.log(err);
  //   }

  // }

  // useEffect(() => {
  //   axios
  //     .get(baseUrl + "/recruiter/JobCategories/listt/")
  //     .then((res) => {
  //       setJobCategories(res.data.data);
  //       console.log(res.data.data);
  //     })
  //     .catch((err) => console.log(err.message));
  // }, [])










  return (
    <>
      {
        loaderStart == true ? (<Loader />) : null
      }
      <>
        <img src="./images/password.png" alt="" className="login-img" />

        <p className="text text-center">
          {lang && Object.keys(lang).length > 0 ? lang[ln]?.LoginPassword["Please enter your mobile number to complete the login process."] : ""}
        </p>
        <div className="">
          <div className="input-container my-2">
            <PhoneInput inputStyle={{ width: '100%', fontSize: '21px', border: '0.5px solid gray' }}
              inputClassName='reactphoneinput'
              placeholder={t("Enter Mobile Number")}
              type='text'
              country={countryCod}
              enableSearch={true}
              defaultValue='+358'
              onChange={(phone, selectedCountry) => {
                const phoneNumberWithoutCode = phone.replace(selectedCountry.dialCode, '');
                console.log(phoneNumberWithoutCode, "ow")
                setChecknumber(phoneNumberWithoutCode)
                setPhone(phone)
                setCountryCode(selectedCountry.dialCode)
              }}
              name=''
              id='phone'
              onKeyDown={e => e.key === 'Enter' ? handleLogin() : ''}
            />

            {/* <input
            className="input-text w-100 pl-5"
            placeholder="Enter Mobile Number"
            type="text"
            defaultValue='+91'
            onChange={(e) => { setPhone(e.target.value) }}
            name=""
            id="phone"
          /> */}
            {/* <img src="./images/call.png" alt="" className="left-img" /> */}
          </div>
          <div className="input-container my-2 mt-3">
            <input
              className="input-text w-100 pl-5 passwordLoginInput" style={{ borderRadius: "5px" }}
              placeholder={lang && Object.keys(lang).length > 0 ? lang[ln]?.SignUp["Enter Password"] : ""}
              type={showPassword ? 'text' : "password"}
              // type="password"
              onChange={(e) => { setPassword(e.target.value) }}
              name=""
              id="pwd"
              onKeyDown={e => e.key === 'Enter' ? handleLogin() : ''}
            />
            <span onClick={() => setShowPassword(!showPassword)} style={{ cursor: 'pointer', position: 'absolute', right: '15px', top: '30%' }} >
              {showPassword ? <i className="fa fa-eye" aria-hidden="true" /> : <i class="fa fa-eye-slash" aria-hidden="true" />}
            </span>
            <img src="./images/lock.png" alt="" className="left-img" />
          </div>
        </div>
        <button className="theme-btn mt-1" type="submit" onClick={handleLogin} onKeyDown={e => e.key === 'Enter' ? handleLogin() :
          ''} >
          {lang && Object.keys(lang).length > 0 ? lang[ln]?.new["Sign In"] : ""}
        </button>

        {/* <button className="theme-btn-fb mt-1" style={{color:'white', backgroundColor:"blue"}} onClick={handleFBLogin} >
     <img src="./images/facebook.png" className="mx-2"   style={{width:'20px', height:'22px'}}/>
        Continue with  Facebook
      </button> */}
        {/* <button className="theme-btn-sign mt-1" 
      onClick={handleGoogle} >
        <img src="./images/google.png" className="mx-2"   style={{width:'20px', height:'20px'}}/>
         Continue with  Google
       
      </button> */}

        {/* <button className="theme-btn mt-1" onClick={handleLogin}>
        Login
      </button> */}
        <div className="d-flex space-between mt-2">
          <p
            className="text-center link mt-2 text-underline login-link"
            onClick={() => {
              props?.setActiveSection(2)
            }}
          >
            {lang && Object.keys(lang).length > 0 ? lang[ln]?.LoginPassword["Forgot Password"] : ""}

          </p>
          <Link
            to="/registration"
            className="text-center link mt-2 text-underline login-link"
          >
            {lang && Object.keys(lang).length > 0 ? lang[ln]?.MyProfile["Create an Account"] : ""}
          </Link>
        </div>
      </>
    </>

  );
};

export default Login;
